import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export const INICIO = 'inicio';

export function setupInicio(): void {
  applicationModuleRegistry.register({
    entry: INICIO,
    id: INICIO,
    name: `beneficiary.${INICIO}`,
    route: Routes.DASHBOARD,
    order: 1,
  });
}
